import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import UserInfo from "../../components/userinfo"
import { useUser } from '../../contexts/UserContext'
import './index.css'
import icon1 from '../../images/icon1.png'
import icon2 from '../../images/icon2.png'
import icon3 from '../../images/icon3.png'
import icon4 from '../../images/icon4.png'
import icon5 from '../../images/icon5.png'
import icon6 from '../../images/icon6.png'
import icon7 from '../../images/icon7.png'
export default function Home() {
    const navigate = useNavigate()
    const location = useLocation()
    const { userInfo, isAdmin, isDriver, loading, refreshUserInfo } = useUser()
    const [hasRefreshed, setHasRefreshed] = useState(false)

    // 检查用户信息是否完整
    const isUserInfoComplete = () => {
        if (!userInfo) return false
        const hasUserId = userInfo.user_id || userInfo.open_id
        // 对于首页，只需要检查user_id是否存在
        // 权限状态(isAdmin, isDriver)在UserContext中单独检查
        return hasUserId !== ''
    }

    // 监听路由变化，当进入首页时自动刷新
    useEffect(() => {
        // 只有当路由是首页且还未刷新过时
        if (location.pathname === '/' && !hasRefreshed) {
            console.log('进入首页，自动刷新用户信息...')
            setHasRefreshed(true)
            
            // 延迟刷新，确保页面已完全加载
            const timer = setTimeout(() => {
                refreshUserInfo()
            }, 500)
            
            return () => clearTimeout(timer)
        }
    }, [location.pathname, hasRefreshed, refreshUserInfo])

    // 在首页刷新时，如果用户信息有缺失则重新获取
    useEffect(() => {
        // 只有在加载完成后、用户信息不完整且还未刷新过时才重新获取
        if (!loading && !isUserInfoComplete() && hasRefreshed) {
            console.log('用户信息不完整，重新获取...')
            refreshUserInfo()
        }
    }, [loading, userInfo, refreshUserInfo, hasRefreshed])

    const handleReserveCar = () => {
        navigate('/vehicle-select')
    }

    const handleMyReservations = () => {
        navigate('/my-reservations')
    }

    const handleApproval = () => {
        navigate('/car-approval')
    }

    const handleReturnApproval = () => {
        navigate('/car-return-approval')
    }

    const handleCarReport = () => {
        navigate('/car-report')
    }

    const handleDelayApproval = () => {
        navigate('/delay-approval')
    }

    const handleDispatchCar = () => {
        navigate('/dispatch')
    }

    return (
        <div className="home">
            <UserInfo userInfo={userInfo} />
            <div className="reserve-container">
                <div className="reserve-card" onClick={handleReserveCar}>
                    <img src={icon1} alt="预约用车" />
                    <div>预约用车</div>
                </div>
                <div className="reserve-card" onClick={handleMyReservations}>
                    <img src={icon2} alt="预约记录" />
                    <div>预约记录</div>
                </div>
                {isAdmin && (
                    <>
                        <div className="reserve-card" onClick={handleDispatchCar}>
                            <img src={icon3} alt="直接派车" />
                            <div>直接派车</div>
                        </div>
                        <div className="reserve-card" onClick={handleApproval}>
                            <img src={icon4} alt="用车审批" />
                            <div>用车审批</div>
                        </div>
                        <div className="reserve-card" onClick={handleDelayApproval}>
                            <img src={icon5} alt="延期审批" />
                            <div>延期审批</div>
                        </div>
                    </>
                )}
                
                {/* 还车审批和用车报表对管理员和司机开放 */}
                {(isAdmin || isDriver) && (
                    <>
                        <div className="reserve-card" onClick={handleReturnApproval}>
                            <img src={icon6} alt="还车审批" />
                            <div>还车审批</div>
                        </div>
                        <div className="reserve-card" onClick={handleCarReport}>
                            <img src={icon7} alt="用车报表" />
                            <div>用车报表</div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}